module.exports = __webpack_public_path__ + "img/OxygenMask.bdd81810.svg";